module.exports = __webpack_public_path__ + "img/product-7-INTqinyou.45173a60.png";